export class Navbar {
  navbar: HTMLElement;
  shadow: HTMLElement;
  hamburgerMenuButtons: HTMLButtonElement[] = [];
  isOpened: boolean = false;

  constructor() {
    this.navbar = document.querySelector('[data-navbar]')!;
    this.shadow = this.navbar.parentElement!;

    this.hamburgerMenuButtons = Array.from(document.querySelectorAll('[data-hamburger-menu-button]')!);

    this.bindEvents();
  }

  private bindEvents() {
    for (const button of this.hamburgerMenuButtons) {
      button.addEventListener('click', () => {
        if (this.isOpened) {
          this.close();
        } else {
          this.open();
        }
      });
    }

    this.shadow.addEventListener('click', evt => {
      const targetClass = 'mobile-nav';

      // Get the full event path
      const path = evt.composedPath() ?? [];

      // Loop through the path and check if any element has the class
      for (const element of path) {
        if (element instanceof HTMLElement && element.classList && element.classList.contains(targetClass)) {
          // Prevent the action if any element in the path has the target class
          return;
        }
      }
      this.close();
    });
  }

  public open() {
    this.shadow.classList.add('mobile-nav__shadow--shown');
    this.shadow.classList.add('mobile-nav__shadow--visible');
    this.navbar.classList.add('mobile-nav--opened');
    this.isOpened = true;
    this.disableBodyScroll();
  }

  public close() {
    this.navbar.classList.remove('mobile-nav--opened');
    setTimeout(() => {
      this.shadow.classList.remove('mobile-nav__shadow--visible');

      setTimeout(() => {
        this.shadow.classList.remove('mobile-nav__shadow--shown');
      }, 300);
    }, 300);
    this.isOpened = false;
    this.enableBodyScroll();
  }

  private disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  private enableBodyScroll() {
    document.body.style.overflow = 'auto';
  }
}
